import { Button } from '@dittolive/anvil'
import { useState } from 'react'
import { getAuthClient } from 'utils/portalAuth'

export function VerificationPending({
  email,
  onBack,
}: {
  email: string
  onBack: () => void | Promise<void>
}) {
  const [busy, setBusy] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  const resend = async () => {
    setBusy(true)
    setMessage('')
    setError('')
    try {
      const result = await getAuthClient().sendVerificationEmail({
        email,
        callbackURL: '/verify-email',
      })
      if (result.error) {
        setError('We could not send the verification email. Please try again.')
      } else {
        setMessage(
          'Verification email requested. Check your inbox and spam folder.',
        )
      }
    } catch {
      setError(
        'We could not reach the authentication service. Please try again.',
      )
    } finally {
      setBusy(false)
    }
  }

  const back = async () => {
    setBusy(true)
    setError('')
    try {
      await onBack()
    } catch {
      setError('Could not log out of this account. Please try again.')
      setBusy(false)
    }
  }

  return (
    <div className="space-y-4">
      <p role="status">
        Verify your email before entering Portal. Check the inbox for{' '}
        {email || 'your account'} and follow the verification link.
      </p>
      <p>
        If the email has not arrived or the link has expired, request another
        below.
      </p>
      {error && <p role="alert">{error}</p>}
      {message && <p role="status">{message}</p>}
      <Button
        type="button"
        variant="secondary"
        onClick={resend}
        disabled={busy || !email}
        aria-busy={busy}
      >
        {busy ? 'Requesting email…' : 'Resend verification email'}
      </Button>
      <p>
        <Button
          type="button"
          variant="secondary"
          disabled={busy}
          onClick={back}
        >
          Back to login
        </Button>
      </p>
    </div>
  )
}
